import { useEffect } from 'react';
import { Keysets } from '../enums/keys.js';

const comboboxInputKeys = [
    'ArrowUp',
    'ArrowDown',
    'End',
    'Home'
];
const comboboxDivKeys = [
    ' ',
    'Space',
    'ArrowUp',
    'ArrowDown',
    'End',
    'Home'
];
const keyMap = {
    [Keysets.ComboboxDiv]: comboboxDivKeys,
    [Keysets.ComboboxInput]: comboboxInputKeys
};
const preventKeyboardScrollingKeyboardEvent = (e, keyset = Keysets.ComboboxDiv)=>{
    if (keyMap[keyset].includes(e.key)) {
        e.preventDefault();
    }
};
/**
 * Prevent the window from scrolling when using a keyboard to arrow down and up inside of a listbox.
 *
 * @returns void
 */ const usePreventKeyboardScrolling = (keyset = Keysets.ComboboxDiv)=>{
    useEffect(()=>{
        const listener = (e)=>preventKeyboardScrollingKeyboardEvent(e, keyset);
        window.addEventListener('keydown', listener, false);
        return ()=>window.removeEventListener('keydown', listener);
    });
};

export { preventKeyboardScrollingKeyboardEvent, usePreventKeyboardScrolling };
//# sourceMappingURL=use-prevent-keyboard-scrolling.js.map
